import { createContext, useContext } from 'react'
import type { AppUpdateSource } from '@/analytics/enums/app-update.enums'

export type ApplyUpdateOptions = {
  source: AppUpdateSource
  policyStateVersion?: string
  simulateIfNoWorker?: boolean
}

export type PWAUpdateContextValue = {
  updateAvailable: boolean
  isApplying: boolean
  applyFailureCount: number
  applyUpdate: (options: ApplyUpdateOptions) => Promise<void>
}

export const PWAUpdateContext = createContext<PWAUpdateContextValue | null>(null)

export function usePWAUpdate() {
  const context = useContext(PWAUpdateContext)
  if (!context) throw new Error('usePWAUpdate must be used inside PWAUpdateProvider')
  return context
}
